import { html } from 'lit';
const Tool =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' d="M20.25 9.5q-.001-.33-.038-.652L18.53 10.53a3.578 3.578 0 0 1-5.06-5.06l1.681-1.683a5.75 5.75 0 0 0-5.961 7.926.75.75 0 0 1-.16.818l-4.836 4.835a1.25 1.25 0 0 0 0 1.768l.672.672.095.086c.49.4 1.215.371 1.673-.086l4.835-4.835.085-.073a.75.75 0 0 1 .733-.088c.68.283 1.427.44 2.213.44a5.75 5.75 0 0 0 5.75-5.75m1.5 0a7.25 7.25 0 0 1-9.562 6.871l-4.494 4.495a2.75 2.75 0 0 1-3.68.189l-.208-.189-.672-.672a2.75 2.75 0 0 1 0-3.888l4.494-4.496a7.25 7.25 0 0 1 9.259-9.158l.087.037a.75.75 0 0 1 .196 1.202l-2.64 2.64a2.079 2.079 0 0 0 2.94 2.939l2.64-2.64.072-.063a.75.75 0 0 1 1.166.346c.26.749.402 1.552.402 2.387"/>
  </svg>
`;
export default Tool;
